import { createContext, ReactNode, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InjectedComponentStore {}

const InjectedComponentStoreContext = createContext<InjectedComponentStore>({});

export function useInjectedComponent<T extends keyof InjectedComponentStore>(
  name: T,
): InjectedComponentStore[T] {
  return useContext(InjectedComponentStoreContext)[name];
}

export interface InjectedComponentProviderProps {
  components: InjectedComponentStore;
  children?: ReactNode;
}

export function InjectedComponentProvider({
  components,
  children,
}: InjectedComponentProviderProps) {
  const parentContext = useContext(InjectedComponentStoreContext);
  return (
    <InjectedComponentStoreContext.Provider
      value={{ ...parentContext, ...components }}
    >
      {children}
    </InjectedComponentStoreContext.Provider>
  );
}
